import {Skeleton, Table, TableCell, TableHeading} from "@nike/eds";
import React from "react";
import {DownloadLink} from "./DownloadLink";

export function CustomsInventoryCountTable({loading, inventoryCount, reportS3Bucket, reportRegion}) {
    const headers = ["ELC", "Genk", "Transit", "Diverts in Transit"];

    const elc = (inventoryCount?.ELC ?? []);
    const genk = (inventoryCount?.GENK ?? []);
    const transit = (inventoryCount?.TRANSIT ?? []);
    const diverts = (inventoryCount?.DIVERTS_IN_TRANSIT ?? []);
    console.log("inventoryCount" + JSON.stringify(inventoryCount));
    return (
        <div className="downloadTable">
            <Table>
                <thead>
                    <tr>
                        {headers.map(header => (
                            <TableHeading key={header}>{header}</TableHeading>
                        ))}
                    </tr>
                </thead>
                <tbody>
                {loading && (
                    <tr>
                        {headers.map((h) => (
                            <TableCell key={h}>
                                <Skeleton height={35} width={"100%"} />
                            </TableCell>
                        ))}
                    </tr>
                )}

                {!loading &&
                    Array.from({ length: 4 }).map((_, i) => (
                        <tr key={i}>
                            <TableCell><DownloadLink type={"elc"} payloadBucket={reportS3Bucket} payloadRegion={reportRegion} payloadPath={elc[i] ? elc[i].path : ''} payloadVersion={elc[i] ? elc[i].version : ''} /></TableCell>
                            <TableCell><DownloadLink type={"genk"} payloadBucket={reportS3Bucket} payloadRegion={reportRegion} payloadPath={genk[i] ? genk[i].path : ''} payloadVersion={genk[i] ? genk[i].version : ''} /></TableCell>
                            <TableCell><DownloadLink type={"report"} payloadBucket={reportS3Bucket} payloadRegion={reportRegion} payloadPath={transit[i] ? transit[i].path : ''} payloadVersion={transit[i] ? transit[i].version : ''} /></TableCell>
                            <TableCell><DownloadLink type={"diverts"} payloadBucket={reportS3Bucket} payloadRegion={reportRegion} payloadPath={diverts[i] ? diverts[i].path : ''} payloadVersion={diverts[i] ? diverts[i].version : ''} /></TableCell>
                        </tr>
                    ))
                }
                </tbody>
            </Table>
        </div>
    );
}